var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-message", class: _vm.type && "form-" + _vm.type },
    [
      _c(
        "button",
        {
          staticClass: "float-right icon-button",
          attrs: { title: "Close message" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c("i", {
            staticClass: "fas fa-times",
            attrs: { title: "Close message" }
          })
        ]
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }